// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { sendTextToClipBoard } = require('utilities/clipBoardHelper');

class RACgdNumber extends React.Component {
    constructor(props) {
        super(props);
        this.copyText = this.copyText.bind(this);
    }

    copyText() {
        sendTextToClipBoard(this.props.cgdNumberVal);
    }

    render() {
        const cgdNumber = this.props.cgdNumberVal;
        const lastFourDigitOfNumber = getLastNChars(cgdNumber);
        const cgdText = (
            <FormattedText
                value="raAccountDetail-cgdText"
                injectedStrings={[lastFourDigitOfNumber]}
            />
        );
        const target = <div>{cgdText}</div>;
        const content = (
            <div>
                {cgdNumber}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={this.copyText} // eslint-disable-line
                />
            </div>
        );
        return (
            <div>
                <OKTooltip
                    content={content}
                    offset={[0, -15]}
                    target={target}
                />
            </div>
        );
    }
}

RACgdNumber.propTypes = {
    cgdNumberVal: PropTypes.number,
};

module.exports = RACgdNumber;
